import raf from "raf";
import domready from "domready";
import debounce from "debounce";
import now from "performance-now";
import Simplex from "./util/noise";

import { CIRCLE_RESOLUTION } from "./circles/circle";
import LogoCircles from "./circles";
import Terrain from "./terrain/terrain";
import allocate from "./util/allocate";

import AABB from "./util/aabb";

let renderFlag = true;
let skipFrames = false;

let circleCtx;
let terrainCtx;
let logoElem;

let lastTime;

let circles, terrain;

const GOLDEN_FACTOR = 0.61803398875;
const UPDATE_INTERVAL = 20;

const NUM_CIRCLES = 5;
const DRAW_CONTROL_POINTS = false;

// coordinates of the graphical center of the logo
const LOGO_CENTER_X = 349;
const LOGO_CENTER_Y = 52;

import CIRCLE_CONFIG from "./circles/config";

/**
 * Stats structure that contains aggregated data: a bounding box, a point buffer for control point debug lines.
 *
 * AABB/buffer gets recycled over and over to avoid runtime allocation.
 *
 * @type {{aabb: AABB, terrainY: number, cpLine: (*), cpPos: number}}
 */

function Stats()
{
    this.aabb = new AABB();
    this.terrainY = 0;
    this.cpLine = (DRAW_CONTROL_POINTS &&  process.env.NODE_ENV !== "production") ? allocate(NUM_CIRCLES * CIRCLE_RESOLUTION * 8) : null;
    this.cpPos = 0;

    this.count = 0;
    this.overdraw = 0;
    this.overLine = 0;
}

let stats;

function px(n)
{
    return (n|0) + "px";
}

function onMouseMove(ev)
{
    ev = ev || window.event;

    let mouseX = ev.pageX;
    let mouseY = ev.pageY;
    if (mouseX === undefined)
    {
        mouseX = ev.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        mouseY = ev.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }

    circles.onMouseMove(mouseX, mouseY);
    terrain.updateMouse(mouseX, mouseY)
}

function onMouseDown(ev)
{
    ev = ev || window.event;

    let mouseX = ev.pageX;
    let mouseY = ev.pageY;
    if (mouseX === undefined)
    {
        mouseX = ev.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        mouseY = ev.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }

    circles.onMouseDown(mouseX, mouseY);
}

function initSize(width, height)
{
    //console.log("INIT FX SIZE", width, height);

    const circleCanvas = circleCtx.canvas;

    circleCanvas.width = width;
    circleCanvas.height = height;


    if (logoElem)
    {
        logoElem.style.left = px(width / 2 - LOGO_CENTER_X);
        logoElem.style.top = px(height / 2 - LOGO_CENTER_Y);
    }

    const circlesSize = 500;

    const circlesX = width / 2 - circlesSize / 2;
    const circlesY = height / 2 - circlesSize / 2;

    circles = new LogoCircles(circleCtx, circlesX, circlesY, circlesSize, CIRCLE_CONFIG);

    window.onmousemove = onMouseMove;
    window.onmousedown = onMouseDown;
    window.onmouseup = circles.onMouseUp;

    const terrainHeight = window.innerHeight * GOLDEN_FACTOR;
    const terrainY = height - terrainHeight;

    const terrainCanvas = terrainCtx.canvas;

    terrainCanvas.style.top = px(terrainY);
    terrainCanvas.width = width;
    terrainCanvas.height = terrainHeight;

    terrain = new Terrain(terrainCtx, 0, 0, width, terrainHeight, now());

    stats = new Stats()
}

function renderLoop()
{

    if (renderFlag)
    {
        const time = now();

        let delta = time - lastTime;

        stats.cpPos = 0;

        // we consume time in discrete steps
        while (delta > UPDATE_INTERVAL)
        {
            circles.update(stats);

            delta -= UPDATE_INTERVAL;
        }

        // remember the current time corrected by the time not consumed in this render loop run
        lastTime = time - delta;

        // render current state
        terrain.render(time, stats);
        circles.clear(stats);
        circles.render(stats);

    }

    renderFlag = !skipFrames || !renderFlag;

    raf(renderLoop);
}

function initSizeFromWindow()
{
    const width = window.innerWidth;
    const height = window.innerHeight;
    initSize(width, height);
}


domready(function ()
{
    const circleElem = document.getElementById("circle-screen");
    const terrainCanvas = document.getElementById("terrain-screen");

    if (circleElem && terrainCanvas)
    {
        circleCtx = circleElem.getContext("2d");
        terrainCtx = terrainCanvas.getContext("2d");

        logoElem = document.getElementById("dm-logo");

        if (logoElem)
        {
            logoElem.ondragstart = (ev) => {
                ev.preventDefault();
                return false;
            };
        }

        window.onresize = debounce(initSizeFromWindow, 200);

        initSizeFromWindow();

        lastTime = now();
        raf(renderLoop);
    }
});

/**
 * If set to true, only render every second frame.
 *
 * @param {?boolean} value     whether to reduce rendering or not, default false. If not given, the current value is returned
 *
 * @returns {boolean}   the current skipFrames value
 */
export function reduceUpdates(value)
{
    if (value !== undefined)
    {
        skipFrames = !!value;
    }
    return skipFrames;
}

export function getStats()
{
    return stats;
}

export { Simplex };





// WEBPACK FOOTER //
// ./src/index.js